// frontend/src/pages/AdminLayout.js – Admin shell layout

import React from "react";
import "../App.css";

export default function AdminLayout({ active = "dashboard", onGo, children }) {
  const canGo = typeof onGo === "function";

  function SideItem({ id, label, disabled }) {
    const isActive = active === id;
    const cls =
      "ns-admin-sideitem" +
      (isActive ? " is-active" : "") +
      (disabled ? " is-disabled" : "");

    function handleClick() {
      if (!canGo) return;
      if (disabled) return;

      // Map sidebar IDs to App-level routes
      if (id === "beta") return onGo("adminBetaFeedback");
      if (id === "dashboard") return onGo("admin");

      // Keep these for future use
      return onGo(id);
    }

    return (
      <button type="button" className={cls} onClick={handleClick}>
        {label}
      </button>
    );
  }

  return (
    <div className="ns-admin-wrap">
      <div className="ns-admin-topbar">
        <div className="ns-admin-title">NEXTSCENES</div>
        <div className="ns-admin-subtitle">ADMIN DASHBOARD</div>
      </div>

      <div className="ns-admin-body">
        <div className="ns-admin-sidebar">
          <SideItem id="dashboard" label="Dashboard" />
          <SideItem id="beta" label="Beta Feedback" />
          <SideItem id="users" label="Users (soon)" disabled />
          <SideItem id="content" label="Content (soon)" disabled />
          <SideItem id="system" label="System (soon)" disabled />
        </div>

        <div className="ns-admin-main">{active === "beta" ? <div className="admin-beta-feedback">{children}</div> : children}</div>
      </div>
    </div>
  );
}
